/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { DashboardDataFilter, Group } from '../constants/telosair-interfaces';
import FloorMapCarousel from './FloorMapCarousel';

type FloorMapWidgetProps = {
  groups: Group[];
  loading: boolean;
  extendedLabel: string;
  dataFilter: DashboardDataFilter | null;
  setDataFilter?: (filter: DashboardDataFilter | null) => void;
};

/**
 * Displays a list of devices and their parameter values.
 * @param props - FloorMapWidget Properties.
 * @returns A React element representing the Devices component.
 */
export default function FloorMapCarouselWidget(props: FloorMapWidgetProps): ReactElement {
  const { groups, loading, dataFilter, extendedLabel, setDataFilter } = props;
  const navigate = useNavigate();

  return (
    <div className="p-4 shadow-md relative flex flex-1 flex-col bg-container-500 rounded">
      <Header
        sectionName="Floor Map"
        showIcon
        actionButton={() => navigate('/settings/device-setup?tab=groups')}
        actionButtonText="Settings"
      >
        <span className="text-sm font-regular text-gray-400 cursor-default">{extendedLabel}</span>
      </Header>
      <FloorMapCarousel
        groups={groups}
        loading={loading}
        dataFilter={dataFilter}
        setDataFilter={setDataFilter}
      />
    </div>
  );
}
